import { useQuery } from "@tanstack/react-query";
import { getLocation } from "app/api/location_api";

const useGetLocationSuggestion = ({ input, state = null, country = null, select = (data) => data }) => {
  return useQuery({
    queryKey: ["get_location_suggestion", input, state, country],
    queryFn: () => getLocation(input, state, country),
    select: select,
    enabled: !!input,
    staleTime: Infinity
  });
};

export default useGetLocationSuggestion;
